var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidden(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.794a3.835 3.835 0 01-3.798-3.592L2.918 8.016c-.374.466-.701.968-.976 1.5a.879.879 0 000 .787A8.509 8.509 0 009.5 15.088a8.13 8.13 0 002.069-.283l-1.379-1.082a3.75 3.75 0 01-.69.07zm8.336 1.567L14.9 13.056a8.883 8.883 0 002.157-2.748.88.88 0 000-.787A8.508 8.508 0 009.5 4.73a8.082 8.082 0 00-3.913 1.017L2.207 3.09a.419.419 0 00-.596.077l-.522.682a.434.434 0 00-.046.454c.028.059.07.11.12.152l15.63 12.27a.425.425 0 00.596-.076l.522-.682a.436.436 0 00-.075-.606zm-4.88-3.83l-1.044-.82c.088-.258.134-.529.138-.802v-.034A2.539 2.539 0 009.533 7.32c-.24.001-.477.037-.706.106.16.22.247.486.248.758a1.275 1.275 0 01-.041.27L7.082 6.917A3.737 3.737 0 019.5 6.025a3.855 3.855 0 013.455 5.504l.001.002z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default ForwardRef;